import { defineStore } from 'pinia';

export const useAnnouncementStore = defineStore('announcement', {
  state: () => ({
    announcements: [],
    loading: false,
  }),
  actions: {
    async fetchAnnouncements() {
      if (this.announcements.length) {
        return;
      }

      this.loading = true;
      const { find } = useStrapi();
      try {
        const data = await find('aa-announcements', {
          sort: 'createdAt:desc'
        });
        this.announcements = data;
      } catch (error) {
        console.error("Error fetching announcements:", error);
      } finally {
        this.loading = false;
      }
    },
  },
});
